import { render } from "./AdvanceDetail.vue?vue&type=template&id=49116c92&scoped=true"
import script from "./AdvanceDetail.vue?vue&type=script&lang=js"
export * from "./AdvanceDetail.vue?vue&type=script&lang=js"

import "./AdvanceDetail.vue?vue&type=style&index=0&id=49116c92&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src766051562/src/medoor-medical-records/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49116c92"]])

export default __exports__